import { Injectable } from '@angular/core';
import { FiBackendService } from '../../shared/fi-backend/fi-backend.service';
import { LoadingService } from '../../shared/fi-loading/loading.service';
import { ILoginReminder, ILoginReminderLog, ILoginReminderSentOverview } from './fi-login-reminder';
import { FiLoginReminderHelperService } from './fi-login-reminder-helper.service';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class FiLoginReminderService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private fiLoginReminderHelperService: FiLoginReminderHelperService,
    ) {}

    getLoginReminder(): Promise<ILoginReminder> {
        const promise = new Promise<ILoginReminder>((resolve, reject) => {
            this.fiBackend.fetchData<ILoginReminder>(`Core/LoginReminder/GetLoginReminder`).then((response) => {
                const loginReminder: ILoginReminder = response ?? this.fiLoginReminderHelperService.getNewInstance();
                if (response) {
                } else {
                }
                resolve(loginReminder);
            }, reject);
        });
        return promise;
    }

    saveLoginReminder(loginReminder: ILoginReminder): Promise<number> {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<number>(`Core/LoginReminder/SaveLoginReminder`, loginReminder),
        );
    }

    sendLoginReminderPreview(contact: string, message: string) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`Core/LoginReminder/SendLoginReminderPreview`, {
                contact,
                message,
            }),
        );
    }

    sendLoginReminder(userId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`Core/LoginReminder/SendLoginReminder?userId=${userId}`),
        );
    }

    getLoginReminderLogsListData(parameter: IItemsListParameterBase) {
        const promise = this.fiBackend.fetchDataPost<IItemsListDataFetchResult<ILoginReminderLog>>(
            'Core/LoginReminder/GetLoginReminderLogsListData',
            parameter,
        );
        return promise;
    }

    getLoginReminderSentOverview() {
        return this.fiBackend.fetchDataPost<ILoginReminderSentOverview>(
            `Core/LoginReminder/GetLoginReminderSentOverview`,
        );
    }
}
